import React, { memo, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import MapPolygon from '../../MapObjects/MapPolygon';
import MapFieldHole from '../../MapObjects/MapFieldHole';
import { deselectFieldHole } from '../../../reducers/FieldReducer';
import InnerBoundariesConfirmActionPopover from './InnerBoundariesConfirmActionPopover';
import { Coordinate, CoordinateObject, Ring, PolygonCoordinates } from '../../../../types/geo';

const mapStoreToProps = (store: any) => ({
  selectedField: store.field.selectedField,
  isDrawingFieldHole: store.field.isDrawingFieldHole,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

const AddEditInnerBoundaries: React.FC<PropsFromRedux> = ({
  selectedField,
  isDrawingFieldHole,
  dispatch,
}) => {
  const [visibleFieldHoles, setVisibleFieldHoles] = useState<PolygonCoordinates>(
    selectedField.polygon.coordinates.slice(1)
  );
  const [coordinates, setCoordinates] = useState<CoordinateObject[]>(
    selectedField.polygon.coordinates.map((ring: Ring) => {
      return ring.map((coord: Coordinate): CoordinateObject => {
        return {
          lng: coord[0],
          lat: coord[1],
        };
      });
    })
  );

  useEffect(() => {
    setCoordinates(
      selectedField.polygon.coordinates.map((ring: Ring) => {
        return ring.map((coord: Coordinate): CoordinateObject => {
          return {
            lng: coord[0],
            lat: coord[1],
          };
        });
      })
    );
    setVisibleFieldHoles(selectedField.polygon.coordinates.slice(1));
  }, [selectedField.polygon.coordinates]);

  useEffect(() => {
    return () => {
      dispatch(deselectFieldHole());
    };
  }, [dispatch]);

  return (
    <>
      <MapPolygon
        fillOpacity={0.0}
        fillColor={'white'}
        strokeColor={'rgb(224,210,61)'}
        strokeWeight={2}
        disabled={true}
        coordinates={coordinates}
        selected={false}
        zIndex={0}
      />
      {!isDrawingFieldHole && <InnerBoundariesConfirmActionPopover dispatch={dispatch} />}
      {visibleFieldHoles &&
        visibleFieldHoles.map((boundary, index) => (
          <MapFieldHole
            fieldHole={boundary}
            key={index}
            dispatch={dispatch}
            fieldHoleDisabled={isDrawingFieldHole}
          />
        ))}
    </>
  );
};

const connector = connect(mapStoreToProps);
export default memo(connector(AddEditInnerBoundaries));
